import loginService from "./loginService";

const logoutUser = async (token) => {
    await loginService.logout(token).then((response) => {
        //Suppression des données utilisateurs   
        
    }).catch(error => {
        console.log(error.message)
    });
}


export {logoutUser} ;

